import React, { Component } from 'react';
import { Col, Form, FormGroup, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL } from "../../Utils/Global";
import { getDateFromString } from "../../Utils/Date";

import FileUpload from '../Helper/FileUpload';
import Status from '../Helper/Status';

class Sage extends Component {

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
		super(props);

    this.state = {
      object: {},
      status: {},
      datasource: []
    };
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    let previewGrid = null;
    if(this.state.datasource.length > 0) {
      const options = {
        noDataText: 'Aucune donnée à afficher'
      };

      previewGrid = <BootstrapTable ref={"tablePreview"} data={this.state.datasource} options={options} height="400px" pagination striped hover>
        {this.getPreviewGridHeaders()}
      </BootstrapTable>
    }

    // Rendering the view
    return (
      <div>
        {/* Status information */}
        {status}

  			<Form horizontal onSubmit={this.handleSubmit.bind(this)}>
          <HelpBlock>Import SAGE.</HelpBlock>

          {/* Form content */}
          <FormGroup /> {/* Espace */}
          <FormGroup controlId="file">
            <Col componentClass={ControlLabel} sm={2} smOffset={2}>Fichier (CSV)</Col>
            <Col sm={6}>
              <FileUpload ref="file" mode={this.state.mode} onChange={this.onFileChange.bind(this)} onClear={this.onFileClear.bind(this)} accept={".csv"} />
            </Col>
          </FormGroup>

          {/* Submit button */}
          <FormGroup>
            <Col smOffset={7} sm={1}>
              <Button bsStyle="success" type="submit">Sauvegarder</Button>
            </Col>
          </FormGroup>
  			</Form>

        {previewGrid}

      </div>);
	}

  /**
  * handleSubmit
  * Catch the form submit and treat it
  **/
  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      status: {
        type: 'info',
        message: 'Sauvegarde en cours...'
      }
    }, this.sendFormData);
  }

  /**
  * onFileChange
  * Catch the file field change
  **/
  onFileChange(fileField, file) {
    if(file) {
      const cutFile = file.name.split(".");
      if(cutFile[cutFile.length - 1] === "csv" || cutFile[cutFile.length - 1] === "CSV") {
        var reader = new FileReader();
        reader.onload = this.processCsv.bind(this);
        reader.onerror = function(event) {
          this.setState({
            status: {
              type: 'danger',
              message: 'Erreur de lecture du CSV.'
            }
          });
        }
        reader.readAsText(file, 'ISO-8859-1');
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Le fichier doit être un CSV.'
          }
        });
      }
    }
  }

  /**
  * onFileClear
  * Catch the file field clear
  **/
  onFileClear(fileField) {
    this.setState({
      datasource: []
    });
  }

  /**
  * processCsv
  * Process CSV file reading
  **/
  processCsv(event) {
    const csv = event.target.result;
    let data = csv.split(/\r\n|\n/);
    const [numeroContratIdx, numeroFactureIdx, dateIdx, montantIdx, commentaireIdx] = [0,1,2,3,4];
    let datasource = [];

    for (let i=0; i<data.length; i++) {
      const line = data[i].split(';');

      if(line.length > 1) {
        const montant = parseFloat(line[montantIdx].replace(",", "."));

        const cell = {
          numeroContrat: line[numeroContratIdx],
          numeroFacture: line[numeroFactureIdx],
          dateFacture: line[dateIdx],
          montant: montant,
          commentaire: line[commentaireIdx],
        };

        datasource.push(cell);
      }
    }

    this.setState({
      datasource: datasource
    });
  }

  /**
  * getPreviewGridHeaders
  * Returns the grid headers
  **/
  getPreviewGridHeaders() {
    const fields = [
      {nom: "numeroContrat", libelle: "N° contrat", empty: false},
      {nom: "numeroFacture", libelle: "N° facture", isKey: true, empty: false},
      {nom: "dateFacture", libelle: "Date", isDate: true},
      {nom: "montant", libelle: "Montant", empty: false},
      {nom: "commentaire", libelle: "Commentaire"},
    ];

    return fields.map(field => {
      let props = {
        key: field.nom,
        dataField: field.nom,
        isKey: field.isKey,
        dataSort: true
      };

      if(field.empty === false) {
         props.columnClassName = this.columnClassNameNonEmpty;
      }

      if(field.isDate === true) {
         props.columnClassName = this.columnClassNameDateFormat;
      }

      return <TableHeaderColumn {...props}>{field.libelle}</TableHeaderColumn>;
    });
  }

  /**
  * columnClassNameNonEmpty
  * Returns the cell class according to its value
  **/
  columnClassNameNonEmpty(fieldValue, row, rowIdx, colIdx) {
    return (fieldValue !== undefined && fieldValue !== "") ? '' : 'td-error-empty';
  }

  /**
  * columnClassNameDateFormat
  * Returns the cell class according to its value
  **/
  columnClassNameDateFormat(fieldValue, row, rowIdx, colIdx) {
    const dateValue = getDateFromString(fieldValue);
    return (!fieldValue || dateValue instanceof Date) ? '' : 'td-error-date';
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let state = this.state;

    const datasource = this.getValidDatasource();
    if(datasource === 0) {
      state.status = {
        type: 'danger',
        message: 'Aucune facturation à ajouter.'
      };
      this.setState(state);
      return;
    }

    const method = "POST";
    const path = `${REST_API_URL}facturationencaissements/import`;

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(datasource),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 201) {
        const facturations = JSON.parse(response.entity);
        this.setState({
          status: {
            type: 'success',
            message: facturations.length + ' facturations créées ou mises à jour.'
          },
          datasource: []
        });

        this.refs["file"].onClearClick();

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          },
          datasource: []
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        },
        datasource: []
      });
		});
  }

  /**
  * getRequiredFieldValidationState
  * Returns the validation state for a required field
  **/
  getRequiredFieldValidationState(fieldName) {
    const value = this.state.object[fieldName];
    return (!value || value === undefined) ? "error" : null;
  }

  /**
  * getValidDatasource
  * Returns the datasource with only valid Facturation
  **/
  getValidDatasource() {
    const datasource = this.state.datasource;
    let validDatasource = [];

    for(let i=0; i<datasource.length; i++) {
      const facturation = datasource[i];

      if(this.columnClassNameNonEmpty(facturation.numeroContrat) === ""
      && this.columnClassNameNonEmpty(facturation.numeroFacture) === ""
      && this.columnClassNameDateFormat(facturation.dateFacture) === ""
      && this.columnClassNameNonEmpty(facturation.montant) === "") {
        validDatasource.push(facturation);
      }
    }

    return validDatasource;
  }

}

export default Sage;



// WEBPACK FOOTER //
// ./src/views/Entity/Sage.js